import React from "react";
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import AdminDashboard from "./pages/AdminDashboard";
import Cookies from "js-cookie";
import Login from "./pages/Login";
import ShowUsers from "./pages/ShowUsers";
import AddUser from "./pages/AddUser";
import DeleteUser from "./pages/DeleteUser";
import Countries from "./pages/Countries";
import AddCountry from "./pages/AddCountry";
import UpdateCountry from "./pages/UpdateCountry";
import DeleteCountry from "./pages/DeleteCountry";
import ShowLeads from "./pages/ShowLeads";
import UploadLeads from "./pages/UploadLeads";
import UpdateLead from "./pages/UpdateLead";
import DeleteLead from "./pages/DeleteLead";
import AllLeads from "./pages/AllLeads";
import UpdateProfile from "./pages/UpdateProfile";
import Emails from "./pages/emails/Emails";
import ValidateEmails from "./pages/emails/ValidateEmails";
import SendEmails from "./pages/emails/SendEmails";
import CheckEmails from "./pages/emails/CheckEmails";
import AddEmail from "./pages/emails/AddEmail";
import DeleteEmail from "./pages/emails/DeleteEmail";
import EmailTemplates from "./pages/emails/EmailTemplates";
import AddTemplate from "./pages/emails/AddTemplate";
import DeleteTemplate from "./pages/emails/DeleteTemplate";
import EditTemplate from "./pages/emails/EditTemplate";
import Rebuttals from "./pages/Rebuttals";
import Processes from "./pages/Processes";
import BrandContactDetails from "./pages/BrandContactDetails";
import BriefForms from "./pages/BriefForms";
import ClearanceReports from "./pages/ClearanceReports";
import AttorneyDetails from "./pages/AttorneyDetails";
import AddProcess from "./pages/processes/AddProcess";
import EditProcess from "./pages/processes/EditProcess";
import DeleteProcess from "./pages/processes/DeleteProcess";
import FollowUps from "./pages/FollowUps";

function App() {
  const getUsername = Cookies.get("username");
  const getRole = Cookies.get("user_role");

  return (
    <div>
      {getUsername ?(
        <Routes>
          <Route path="/" element={<AdminDashboard />}></Route>
          <Route path="/followups" element={<FollowUps />}></Route>
          <Route path="/leads/:country" element={<ShowLeads />}></Route>
          <Route path="/countries/:country/process" element={<Processes />}></Route>
          <Route path="/countries/:country/process/addprocess" element={<AddProcess />}></Route>
          <Route path="/countries/:country/process/updateprocess/:id" element={<EditProcess />}></Route>
          <Route path="/countries/:country/process/deleteprocess/:id" element={<DeleteProcess />}></Route>
          <Route path="/countries/:country/rebuttles" element={<Rebuttals />}></Route>
          <Route path="/countries/:country/brief-form" element={<BriefForms />}></Route>
          <Route path="/countries/:country/brand-contact-details" element={<BrandContactDetails />}></Route>
          <Route path="/countries/:country/attorney-details" element={<AttorneyDetails />}></Route>
          <Route path="/countries/:country/clearance-report" element={<ClearanceReports />}></Route>
          <Route path="/updateprofile" element={<UpdateProfile />}></Route>
          {getRole === "Administrator" &&
            <>
              <Route path="/users" element={<ShowUsers />}></Route>
              <Route path="/adduser" element={<AddUser />}></Route>
              <Route path="/deleteuser/:id" element={<DeleteUser />}></Route>
              <Route path="/countries" element={<Countries />}></Route>
              <Route path="/addcountry" element={<AddCountry />}></Route>
              <Route path="/updatecountry/:id" element={<UpdateCountry />}></Route>
              <Route path="/deletecountry/:id" element={<DeleteCountry />}></Route>
              <Route path="/uploadleads" element={<UploadLeads />}></Route>
              <Route path="/updatelead/:id" element={<UpdateLead />}></Route>
              <Route path="/deletelead/:id" element={<DeleteLead />}></Route>
              <Route path="/allleads" element={<AllLeads />}></Route>
              {/* emails routes */}
              <Route path="/emails" element={<Emails />}></Route>
              <Route path="/emails/validate-emails" element={<ValidateEmails />}></Route>
              <Route path="/emails/email-sender" element={<SendEmails />}></Route>
              <Route path="/emails/check-emails" element={<CheckEmails />}></Route>
              <Route path="/emails/addemail" element={<AddEmail />}></Route>
              <Route path="/emails/deleteemail/:id" element={<DeleteEmail />}></Route>
              <Route path="/emails/email-templates/" element={<EmailTemplates />}></Route>
              <Route path="/emails/addtemplate/" element={<AddTemplate />}></Route>
              <Route path="/emails/deletetemplate/:id" element={<DeleteTemplate />}></Route>
              <Route path="/emails/updatetemplate/:id" element={<EditTemplate />}></Route>
            </>
          }
        </Routes>
      ):(
        <Login />
      )
      }
    </div>
  );
}

export default App;
